import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";


const PrivacyPolicy = () => {

    return (

        <>
            <Header />
            <main class="main">
                <div className="breadcrumb-wrap" id="breadcrumb-margin">
                     <div className="banner" style={{minHeight:'10px'}}>
                        <img class="bg-img bg-top" src="assets/images/inner-page/banner-p.html" alt="banner" />

                        <div class="container-lg">
                            <div class="breadcrumb-box">
                                <div class="heading-box">
                                    <h1>Privacy Policy</h1>
                                </div>
                                <ol class="breadcrumb">
                                    <li><a href="/">Home</a></li>
                                    <li>
                                        <a href="javascript:void(0)"><i data-feather="chevron-right"></i></a>
                                    </li>
                                    <li class="current"><a href="">Privacy Policy</a></li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Breadcrumb End --> */}

                <section>
                    <div class="container-lg">
                        <div class="row gy-5 g-lg-3 g-xxl-4">


                            <div class="col-lg-12 order-1 order-lg-2 ratio_36">
                                <div class="blog-wrap">
                                    <div class="blog-box blog-detail">

                                        <div class="content-box">
                                            <h5><i data-feather="clock"> </i>Privacy Policy</h5>
                                            <p>1. Your privacy is very important to us. Accordingly, we have developed this Policy in order for you to understand how we collect, use, communicate and disclose and make use of personal information. The following outlines our privacy policy.</p>
                                            <p>2. Before or at the time of collecting personal information, we will identify the purposes for which information is being collected.</p>
                                            <p>3. We will collect and use personal information solely with the objective of fulfilling those purposes specified by us and for other compatible purposes, unless we obtain the consent of the individual concerned, or as required by law.</p>
                                            <p>4. We will only retain personal information as long as necessary for the fulfilment of those purposes.</p>
                                            <p>5. We will collect personal information by lawful and fair means and, where appropriate, with the knowledge or consent of the individual concerned.</p>
                                            <p>6. Personal data should be relevant to the purposes for which it is to be used, and, to the extent necessary for those purposes, should be accurate, complete, and up-to-date.</p>
                                            <p>7. We will protect personal information against loss or theft with reasonable security safeguards, as well as unauthorized access, disclosure, copying, use or modification.</p>
                                            <p>8. We will make readily available to customers information about our policies and practices relating to the management of personal information.</p>
                                            <p>9. We are committed to conducting our business in accordance with these principles in order to ensure that the confidentiality of personal information is protected and maintained.</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />

        </>
    )
}
export default PrivacyPolicy;